module.exports = __webpack_public_path__ + "static/img/szafa_27_czarna-01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_27_czarna-01.svg
// module id = oSaB
// module chunks = 0